import React from 'react';
import { Box, Skeleton } from '@mui/material';

const WidgetSkeleton = () => (
  <Box sx={{ py: 1 }}>
    <Skeleton variant="text" width="40%" height={36} />
    <Skeleton variant="text" width="90%" />
    <Skeleton variant="text" width="80%" />
    <Skeleton variant="text" width="70%" />
  </Box>
);

export default WidgetSkeleton;
